import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		menuAppBar: {
			top: 'auto',
			bottom: 0,
			background: 'white',
			boxShadow: theme.custom.defaultBoxShadow,
			borderRadius: '16px 16px 0px 0px',
			zIndex: 1350
		}
	};
});
